<template>
    <div class="container">
        <div class="message">
            <p>無使用權限, </p>
            <p>如有疑問請聯系管理員</p>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      adminContact: ''
    }
  }
}
</script>

<style>
    .container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
    }

    .message {
        text-align: center;
        font-size:30px;
    }
</style>
